import React from 'react';

import ReportInfoModule from '../modules/ReportInfoModule.js';
import ReportNarrativeModule from '../modules/ReportNarrativeModule.js';
import ReportAiSuggestionsModule from '../modules/ReportSuggestionsModule.js';
import ReportChecksModule from '../modules/ReportChecksModule.js';
import SchematronModule from '../modules/SchematronModule.js';
import './Box.css';

const ReportFeedbackBox = ({user, reportId, isSmallScreen}) => {
    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>
            <h1 className='box-title'> Report Feedback </h1>
            <ReportInfoModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>
            {!user.subscriptions.includes('CADMUS_AUDITOR') && <ReportNarrativeModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>}
            {user.subscriptions.includes('CADMUS_AUDITOR') && <ReportAiSuggestionsModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>}
            <ReportChecksModule user={user} reportId={reportId} isSmallScreen={isSmallScreen} />
            <SchematronModule user={user} reportId={reportId} isSmallScreen={isSmallScreen} />
        </div>
    );
}

export default ReportFeedbackBox;